export default __webpack_public_path__ + "static/media/portfolio.9d6f5871.webp";